module.exports = __webpack_public_path__ + "static/media/logo@2x.f7f79c47.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/logo@2x.png
// module id = 289
// module chunks = 0